import React from 'react';
import {
    Stack,
    Button,
    TextField,
    Icon,
    Tooltip,
    Select
} from '@shopify/polaris';
import {
    ChevronRightMinor,
    DeleteMajor,
    TextAlignmentCenterMajor
} from '@shopify/polaris-icons';

export function KeywordTagMappingEntry(props) {

    function onKeyUpdate(value) {
        props.onUpdate(props.index, value, props.tag, props.matchWholeWord, props.ruleFields);
    }

    function onValueUpdate(value) {
        props.onUpdate(props.index, props.keyword, value, props.matchWholeWord, props.ruleFields);
    }

    function onMatchUpdate(value) {
        props.onUpdate(props.index, props.keyword, props.tag, value, props.ruleFields);
    }

    function onRuleFieldsUpdate(value) {
        props.onUpdate(props.index, props.keyword, props.tag, props.matchWholeWord, value === "" ? null : value);
    }

    var keywordEmpty = props.keyword == null || props.keyword === "";
    var tagEmpty = props.tag == null || props.tag === "";

    return <div style={{ 'paddingBottom': '10px' }}>
        <Stack alignment="center">
            <Stack.Item>
                <TextField
                    placeholder="Keyword"
                    value={props.keyword}
                    error={keywordEmpty ? "Value is required" : null}
                    onChange={onKeyUpdate}
                    autoComplete="off"
                />
            </Stack.Item>
            <Stack.Item>
                <Icon
                    source={ChevronRightMinor}
                    color="base" />
            </Stack.Item>
            <Stack.Item>
                <TextField
                    placeholder="Metafield value"
                    value={props.tag}
                    error={tagEmpty ? "Value is required" : null}
                    onChange={onValueUpdate}
                    autoComplete="off"
                />
            </Stack.Item>
            <Stack.Item>
                <Select
                    label="Fields"
                    labelHidden
                    options={[
                        {
                            "label": "Fields: Default (rule setting)",
                            "value": ""
                        },
                        {
                            "label": "Fields: Title",
                            "value": "OnlyTitle"
                        },
                        {
                            "label": "Fields: Description",
                            "value": "OnlyDescription"
                        },
                        {
                            "label": "Fields: Title and Description",
                            "value": "TitleAndDescription"
                        }
                    ]}
                    onChange={onRuleFieldsUpdate}
                    value={props.ruleFields == null ? "" : props.ruleFields}
                />
            </Stack.Item>
            <Stack.Item>
                <Tooltip content="Match whole words only" dismissOnMouseOut>
                    <Button pressed={props.matchWholeWord} icon={TextAlignmentCenterMajor} onClick={() => onMatchUpdate(!props.matchWholeWord)}></Button>
                </Tooltip>
                <Button destructive icon={DeleteMajor} onClick={() => props.onDelete(props.index)}></Button>
            </Stack.Item>
        </Stack>
    </div>
}